import { get } from 'lodash-es';
import { STATUS_SUCCESS, STATUS_ERROR, STATUS_LOADING } from 'store/status';

import { GET_STATES_BY_COUNTRIES } from 'modules/v2/publish/store/constants';

import { states as initialState } from './initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_STATES_BY_COUNTRIES}_REQUESTED`: {
      return {
        ...state,
        data: null,
        status: STATUS_LOADING,
      };
    }

    case `${GET_STATES_BY_COUNTRIES}_FAILED`: {
      return {
        ...state,
        status: STATUS_ERROR,
      };
    }

    case `${GET_STATES_BY_COUNTRIES}_SUCCEEDED`: {
      const data = get(action, ['payload'], null);

      return {
        ...state,
        data,
        status: STATUS_SUCCESS,
      };
    }

    default:
      return state;
  }
};

export default reducer;
